import React from 'react';
import TextField from '@mui/material/TextField';

export default function TextBox(props) {

    return (
        <TextField label="" variant="outlined" { ...props}/>
    )
}